export default __webpack_public_path__ + "static/media/highFive.599fa809.png";